import React from "react";

/**
 * KLC monogram — a fresh take on the original "ascending pillars".
 * Three rising bars form an abstract upward motion (growth / advocacy),
 * with the tallest bar in terracotta as the signature accent.
 */
export const LogoMark = ({ size = 34, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 40 40"
    fill="none"
    className={className}
    aria-hidden="true"
  >
    <rect x="6" y="6" width="4.5" height="28" rx="2" fill="currentColor" />
    <path d="M32 8 L15 20 L32 32" fill="none" stroke="currentColor" strokeWidth="4.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M26 6 L34 6 L34 14" fill="none" stroke="#D95A41" strokeWidth="4.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const Logo = ({ light = false, onClick }) => (
  <button
    onClick={onClick}
    data-testid="klc-logo"
    className="flex items-center gap-3 group"
    aria-label="Kamboj Law Chambers home"
  >
    <span className={light ? "text-[#050A14]" : "text-[#F2EFE9]"}>
      <LogoMark />
    </span>
    <span className="flex flex-col items-start leading-none">
      <span
        className={`text-lg font-black tracking-tightest ${
          light ? "text-[#050A14]" : "text-[#F2EFE9]"
        }`}
      >
        KAMBOJ
      </span>
      <span className="text-[10px] font-500 tracking-[0.35em] text-[#94A3B8] uppercase">
        Law Chambers
      </span>
    </span>
  </button>
);
